<template>
    <header>
        <h1>{{ title }}</h1>
        <div class="separator">
            <div class="line"></div>
            <div class="stars">
                <svg-icon icon="star"></svg-icon>
                <div class="star-icon">
                    <svg-icon icon="star"></svg-icon>
                </div>
                <svg-icon icon="star"></svg-icon>
            </div>
            <div class="line"></div>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'title-header',
        props: {
            title: String,
        }
    }
</script>

<style lang="scss" scoped>
header {
    @apply w-full flex flex-col items-center py-1 px-0 mb-10;
    h1 {
        @apply text-center font-bold text-black text-3xl;
    }
}

.separator {
    @apply flex items-center justify-between;
    width: 148px;

    .line {
        @apply bg-secondary;
        width: 48px;
        height: 2px;
    }

    .stars {
        @apply flex items-end justify-between text-secondary;
        width: 38px;

        .icon {
            width: 7.5px;
            height: 7.5px;
        }

        .star-icon {
            .icon {
                width: 10px;
                height: 10px;
            }
        }
    }
}
</style>
